import { getAuth } from 'firebase/auth';
import { doc, getFirestore, setDoc } from 'firebase/firestore';

import { firebaseApp } from '@/services/firebase';
import { FirestoreCollections } from '@/types/firestore';

const firebaseAuth = getAuth();
const firebaseDb = getFirestore(firebaseApp);

export const deleteMediaFromLibrary = async (mediaUUID: string) => {
  const userUUID = firebaseAuth.currentUser?.uid || '';

  if (!userUUID) return;

  try {
    const setMediaIsDeleted = {
      isDeleted: true,
    };

    const docHistory = doc(
      firebaseDb,
      FirestoreCollections.Users,
      userUUID,
      FirestoreCollections.PlayHistory,
      mediaUUID
    );

    setDoc(docHistory, setMediaIsDeleted, { merge: true });
  } catch (error) {
    throw new Error(error);
  }
};
